/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompaniesAdminControllerCreateAdminCompany201Response } from '../models';
// @ts-ignore
import type { CompaniesAdminControllerGetAdminCompanies200Response } from '../models';
// @ts-ignore
import type { CompanyListItemAdminDto } from '../models';
// @ts-ignore
import type { CreateAdminCompanyDto } from '../models';
// @ts-ignore
import type { SetCompanyFeatureFunctionalitiesDto } from '../models';
// @ts-ignore
import type { UpdateCompanyDto } from '../models';
/**
 * CompaniesAdminApi - axios parameter creator
 * @export
 */
export const CompaniesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAdminCompanyDto} createAdminCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerCreateAdminCompany: async (createAdminCompanyDto: CreateAdminCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdminCompanyDto' is not null or undefined
            assertParamExists('companiesAdminControllerCreateAdminCompany', 'createAdminCompanyDto', createAdminCompanyDto)
            const localVarPath = `/api/companies/admin-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerExportAdminCompanies: async (search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/companies/admin-list/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerGetAdminCompanies: async (search?: string, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/companies/admin-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {SetCompanyFeatureFunctionalitiesDto} setCompanyFeatureFunctionalitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerSetCompanyFeatureFunctionalities: async (companyId: string, setCompanyFeatureFunctionalitiesDto: SetCompanyFeatureFunctionalitiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companiesAdminControllerSetCompanyFeatureFunctionalities', 'companyId', companyId)
            // verify required parameter 'setCompanyFeatureFunctionalitiesDto' is not null or undefined
            assertParamExists('companiesAdminControllerSetCompanyFeatureFunctionalities', 'setCompanyFeatureFunctionalitiesDto', setCompanyFeatureFunctionalitiesDto)
            const localVarPath = `/api/companies/admin-list/{companyId}/feature-functionalities`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCompanyFeatureFunctionalitiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateCompanyDto} updateCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerUpdateAdminCompany: async (companyId: string, updateCompanyDto: UpdateCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companiesAdminControllerUpdateAdminCompany', 'companyId', companyId)
            // verify required parameter 'updateCompanyDto' is not null or undefined
            assertParamExists('companiesAdminControllerUpdateAdminCompany', 'updateCompanyDto', updateCompanyDto)
            const localVarPath = `/api/companies/admin-list/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesAdminApi - functional programming interface
 * @export
 */
export const CompaniesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompaniesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAdminCompanyDto} createAdminCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesAdminControllerCreateAdminCompany(createAdminCompanyDto: CreateAdminCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesAdminControllerCreateAdminCompany201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesAdminControllerCreateAdminCompany(createAdminCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesAdminApi.companiesAdminControllerCreateAdminCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesAdminControllerExportAdminCompanies(search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyListItemAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesAdminControllerExportAdminCompanies(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesAdminApi.companiesAdminControllerExportAdminCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesAdminControllerGetAdminCompanies(search?: string, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesAdminControllerGetAdminCompanies200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesAdminControllerGetAdminCompanies(search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesAdminApi.companiesAdminControllerGetAdminCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {SetCompanyFeatureFunctionalitiesDto} setCompanyFeatureFunctionalitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesAdminControllerSetCompanyFeatureFunctionalities(companyId: string, setCompanyFeatureFunctionalitiesDto: SetCompanyFeatureFunctionalitiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesAdminControllerSetCompanyFeatureFunctionalities(companyId, setCompanyFeatureFunctionalitiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesAdminApi.companiesAdminControllerSetCompanyFeatureFunctionalities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateCompanyDto} updateCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesAdminControllerUpdateAdminCompany(companyId: string, updateCompanyDto: UpdateCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesAdminControllerUpdateAdminCompany(companyId, updateCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesAdminApi.companiesAdminControllerUpdateAdminCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompaniesAdminApi - factory interface
 * @export
 */
export const CompaniesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompaniesAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateAdminCompanyDto} createAdminCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerCreateAdminCompany(createAdminCompanyDto: CreateAdminCompanyDto, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesAdminControllerCreateAdminCompany201Response> {
            return localVarFp.companiesAdminControllerCreateAdminCompany(createAdminCompanyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerExportAdminCompanies(search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyListItemAdminDto>> {
            return localVarFp.companiesAdminControllerExportAdminCompanies(search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerGetAdminCompanies(search?: string, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesAdminControllerGetAdminCompanies200Response> {
            return localVarFp.companiesAdminControllerGetAdminCompanies(search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {SetCompanyFeatureFunctionalitiesDto} setCompanyFeatureFunctionalitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerSetCompanyFeatureFunctionalities(companyId: string, setCompanyFeatureFunctionalitiesDto: SetCompanyFeatureFunctionalitiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.companiesAdminControllerSetCompanyFeatureFunctionalities(companyId, setCompanyFeatureFunctionalitiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {UpdateCompanyDto} updateCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesAdminControllerUpdateAdminCompany(companyId: string, updateCompanyDto: UpdateCompanyDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.companiesAdminControllerUpdateAdminCompany(companyId, updateCompanyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompaniesAdminApi - object-oriented interface
 * @export
 * @class CompaniesAdminApi
 * @extends {BaseAPI}
 */
export class CompaniesAdminApi extends BaseAPI {
    /**
     * 
     * @param {CreateAdminCompanyDto} createAdminCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminApi
     */
    public companiesAdminControllerCreateAdminCompany(createAdminCompanyDto: CreateAdminCompanyDto, options?: RawAxiosRequestConfig) {
        return CompaniesAdminApiFp(this.configuration).companiesAdminControllerCreateAdminCompany(createAdminCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminApi
     */
    public companiesAdminControllerExportAdminCompanies(search?: string, options?: RawAxiosRequestConfig) {
        return CompaniesAdminApiFp(this.configuration).companiesAdminControllerExportAdminCompanies(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminApi
     */
    public companiesAdminControllerGetAdminCompanies(search?: string, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return CompaniesAdminApiFp(this.configuration).companiesAdminControllerGetAdminCompanies(search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {SetCompanyFeatureFunctionalitiesDto} setCompanyFeatureFunctionalitiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminApi
     */
    public companiesAdminControllerSetCompanyFeatureFunctionalities(companyId: string, setCompanyFeatureFunctionalitiesDto: SetCompanyFeatureFunctionalitiesDto, options?: RawAxiosRequestConfig) {
        return CompaniesAdminApiFp(this.configuration).companiesAdminControllerSetCompanyFeatureFunctionalities(companyId, setCompanyFeatureFunctionalitiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {UpdateCompanyDto} updateCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminApi
     */
    public companiesAdminControllerUpdateAdminCompany(companyId: string, updateCompanyDto: UpdateCompanyDto, options?: RawAxiosRequestConfig) {
        return CompaniesAdminApiFp(this.configuration).companiesAdminControllerUpdateAdminCompany(companyId, updateCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

